import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function TopServer(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='top-server-glance-body'
                cssHeadingClass='top-server-glance-heading'
                cssIconClass='icons8-waiter'
                Heading={t('TopServer')}
                DataPoint1={props.DP1}
                DataPoint2={'<div>' + props.DP2 + '</div>'}
                DataPoint3={props.DP3 + ' ' + t('Checks')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}